import { render, staticRenderFns } from "./deletearea.vue?vue&type=template&id=2d0e8a5b&scoped=true"
import script from "./deletearea.vue?vue&type=script&lang=js"
export * from "./deletearea.vue?vue&type=script&lang=js"
import style0 from "./deletearea.vue?vue&type=style&index=0&id=2d0e8a5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e8a5b",
  null
  
)

export default component.exports